export const CREDIT_CONSUMPTION_ROWS = [

 
  { label: 'Génération avec GPT', value: '1' },
  { label: 'Génération avec Gemini', value: '5' },
  { label: 'Génération avec Claude', value: '8' },
  { label: 'Génération Claude + GPT', value: '10' },
  { label: 'Génération avec Perplexity', value: '2' },
  { label: 'Génération Title', value: '1' },
  { label: 'Génération Méta-description', value: '1' },
  { label: 'Création Agent IA', value: '3' },
  { label: 'Création texte avec enrichissement', value: '3' },
  { label: 'Traduction IA', value: '3' },
  { label: 'Génération light GAP', value: '1' },
  { label: 'Requête IA dans éditeur de texte', value: '1' },

];

export const isPaymentRequiredError = (error) => {
  if (!error) return false;
  const status = Number(error?.response?.status ?? error?.status);
  return status === 402;
};

export const isPaymentRequiredPayload = (data) => {
  if (data == null) return false;
  if (typeof data === 'number') return data === 402;
  if (typeof data === 'string') return data.trim() === '402';
  if (typeof data !== 'object') return false;
  return Number(data.statusCode ?? data.code ?? data.httpStatus) === 402;
};

export const createPaymentRequiredError = (data, fallbackMessage = 'Payment Required') => {
  const message =
    (typeof data === 'object' &&
      data &&
      (data.message || data.errorMessage || data.error || data.detail)) ||
    fallbackMessage;
  const err = new Error(String(message));
  err.status = 402;
  err.response = {
    status: 402,
    data: data && typeof data === 'object' ? data : { message },
  };
  return err;
};
